<template>
  <div id="app">
    <router-view :key="refreshKey" />
  </div>
</template>
<script>
  import configList from './utils/config'
  export default {
    data() {
      return {
        refreshKey: 0
      }
    },
    watch: {
      '$i18n.locale'(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.refreshKey++
          this.setTitle()
        }
      }
    },
    created() {
      this.setTitle()
    },

    methods: {
      setTitle() {
        let href = location.href
        let config = configList.find((item) => {
          return href.indexOf(item.name) > -1
        })
        if (config) {
          document.title = this.$t(`commonLang.${config.title}`)
          // document.title = config.title
        } else {
          document.title = this.$t('commonLang.智慧储能云平台')
        }
      }
    }
  }
</script>
<style lang="scss">
  #app {
    // height: 100vh;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    // color: #2c3e50;
    background-color: #f0f2f5;
  }
</style>
